import React, { useEffect, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { createRoot } from '@wordpress/element';
import { displayErrorMessage, displayLoader, ConnectionContext, getConnectionInfo } from './utils';
import { getStoredData } from "./utils/data-pulls";
import { SmallMatchBox } from "./components/smallMatchBox";

const UpcomingGridApp = (props) => {
    const { 
        ...restProps 
    } = props;

    // Error and load handling
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);

    // Connection Information
    const [connectionInfo, setConnectionInfo] = useState(null);

    // Matches
    const [ matches, setMatches ] = useState(null);


    /**
     * Get the next bunch of upcoming games
     */
    useEffect(() => {

        // Get our connection info
        getConnectionInfo().then(
            (result) => {
                setConnectionInfo(result.data);
            }
        ).catch(
            (error) => {
                setError(error);
            }
        );

        // Get matches list
        let args = [
            {
                key: 'upcomingMatches',
                number: 6
            }
        ];
        getStoredData(args).then(
            (result) => {

                // Set Matches
                if ( result.data.upcomingMatches ) {
                    setMatches(result.data.upcomingMatches);
                }
                setIsLoaded(true);

            }
        ).catch(
            (error) => {
                setError(error);
            }
        );

    }, []);



    // Bail if we don't have data yet
    if (!isLoaded ) {
        return displayLoader('acaLoader--main');
    }

    return (
        <ConnectionContext.Provider value={connectionInfo}>
            <section className="acaWidget acaWidget--upcomingGrid">

                <ErrorBoundary fallback={displayErrorMessage()}>
                    { matches && matches.length > 0 ? (
                        <div className="acaScheduleGrid">
                            { matches.map((match, i) => (
                                <SmallMatchBox key={i} data={match} />
                            ) ) }
                        </div>
                    ) : displayErrorMessage('No upcoming matches currently. Check back later.')}
                </ErrorBoundary>

            </section>
        </ConnectionContext.Provider>
    );
}

export default UpcomingGridApp;

// Render Match Page
const appContainer = document.getElementById('upcomingGridApp');
const root = createRoot(appContainer);
root.render(<UpcomingGridApp />);